// extracted by mini-css-extract-plugin
export default {"childrenGroup":"ChildrenStatic_childrenGroup__W1eAT"};